import {
    DeliveryTypeCategory as ApiDeliveryTypeCategory,
    PaymentType as AppPaymentType,
} from '@/features/graphql/generated/graphql'
import {
    PaymentType as ApiPaymentType,
    DeliveryTypeCategory as AppDeliveryTypeCategory,
} from '@/features/orders/constants/app'
import {
    apiToAppDeliveryTypeCategory,
    appToApiDeliveryTypeCategory,
} from '@/features/pos/components/OrderFinalization/constants/delivery'
import {
    apiToAppPaymentType,
    appToApiPaymentType,
} from '@/features/pos/components/OrderFinalization/constants/payment'

export const convertDeliveryTypeCategoryToApp = (
    category: ApiDeliveryTypeCategory
): AppDeliveryTypeCategory => apiToAppDeliveryTypeCategory[category]

export const convertDeliveryTypeCategoryToApi = (
    category: AppDeliveryTypeCategory
): ApiDeliveryTypeCategory => appToApiDeliveryTypeCategory[category]

export const convertPaymentTypeToApp = (payment: ApiPaymentType): AppPaymentType =>
    apiToAppPaymentType[payment]

export const convertPaymentTypeToApi = (payment: AppPaymentType): ApiPaymentType =>
    appToApiPaymentType[payment]
